module.exports = __webpack_public_path__ + "img/Flip Card 3.a02b443f.svg";